import PropTypes from "prop-types";
import React from "react";

var JsonLd = function JsonLd(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(data)
    }
  });
};

JsonLd.displayName = "JsonLd";
JsonLd.propTypes = {
  /**
   * Data to be innerHTMLed
   */
  data: PropTypes.object.isRequired
};
export default JsonLd;